<!-- Page Header -->
<div class="page-header">
    <div class="header-content">
        <div>
            <h1 class="page-title">INSTRUCTIVO DE EMBARQUE</h1>
            <p class="page-subtitle">
                Creación de instructivo para el viaje seleccionado
            </p>
        </div>
        <div class="header-actions">
            <button mat-stroked-button color="warn" (click)="cancel()">
                <mat-icon>close</mat-icon>
                Cancelar
            </button>
        </div>
    </div>
</div>

<div class="page-body">
    <!-- Loading state -->
    <div *ngIf="isLoading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando información del viaje…</p>
    </div>

    <!-- Error state -->
    <div *ngIf="loadError && !isLoading" class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ loadError }}</p>
        <button mat-stroked-button (click)="cancel()">
            Volver a Itinerarios
        </button>
    </div>

    <!-- Wizard content -->
    <ng-container *ngIf="!isLoading && !loadError && state?.voyageData">
        <!-- Voyage summary header card -->
        <div class="voyage-card">
            <div class="voyage-header">
                <div class="voyage-title">
                    <mat-icon>directions_boat</mat-icon>
                    <div>
                        <span class="vessel-name">{{
                            state!.voyageData!.vesselName
                        }}</span>
                        <span class="voyage-meta">
                            {{ state!.voyageData!.voyageNumber }} &nbsp;·&nbsp;
                            {{ state!.voyageData!.carrierName }} &nbsp;·&nbsp;
                            {{ state!.voyageData!.portOfLoadingName }} →
                            {{ state!.voyageData!.portOfDischargeName }}
                        </span>
                    </div>
                </div>
                <div class="voyage-dates">
                    <span class="voyage-cutoff-badge">
                        <span class="voyage-cutoff-label">Cut off</span>
                        <strong class="voyage-cutoff-value">
                            <ng-container
                                *ngIf="
                                    state!.voyageData!.cutOffDocumental;
                                    else cutoffMissing
                                "
                            >
                                <span class="voyage-cutoff-date">{{
                                    state!.voyageData!.cutOffDocumental
                                        | date : 'dd-MM-yyyy'
                                }}</span>
                                <span class="voyage-cutoff-at-time">{{
                                    state!.voyageData!.cutOffDocumental
                                        | date : 'HH:mm'
                                }}
                                    hrs</span>
                            </ng-container>
                            <ng-template #cutoffMissing>TBC</ng-template>
                        </strong>
                    </span>
                    <div class="voyage-dates-et">
                        <span
                            >ETD:
                            <strong>{{
                                (state!.voyageData!.etd
                                    | date : 'dd-MM-yyyy') ?? 'TBC'
                            }}</strong></span
                        >
                        <span
                            >ETA:
                            <strong>{{
                                (state!.voyageData!.eta
                                    | date : 'dd-MM-yyyy') ?? 'TBC'
                            }}</strong></span
                        >
                    </div>
                </div>
            </div>
        </div>

        <!-- Stepper -->
        <div class="stepper-card">
            <mat-stepper #stepper [linear]="false" orientation="horizontal">
                <mat-step label="Viaje">
                    <app-step1-viaje></app-step1-viaje>
                    <div class="step-actions">
                        <span></span>
                        <div class="actions-right">
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="next()"
                            >
                                Siguiente <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step label="Booking + Organizaciones">
                    <app-step2-booking-organizaciones></app-step2-booking-organizaciones>
                    <div class="step-actions">
                        <button mat-stroked-button (click)="previous()">
                            <mat-icon>arrow_back</mat-icon> Anterior
                        </button>
                        <div class="actions-right">
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="next()"
                            >
                                Siguiente <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step label="Carga + Financiero">
                    <app-step3-carga-financieros></app-step3-carga-financieros>
                    <div class="step-actions">
                        <button mat-stroked-button (click)="previous()">
                            <mat-icon>arrow_back</mat-icon> Anterior
                        </button>
                        <div class="actions-right">
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="next()"
                            >
                                Siguiente <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step label="Revisión">
                    <app-step4-revision></app-step4-revision>
                    <div class="step-actions">
                        <button mat-stroked-button (click)="previous()">
                            <mat-icon>arrow_back</mat-icon> Anterior
                        </button>
                    </div>
                </mat-step>
            </mat-stepper>
        </div>
    </ng-container>
</div>
